import './ui/styles.css';
import { initApp } from './ui/app';

initApp(document.querySelector('#app') as HTMLElement);
